import binder from 'classnames/bind';
import s from './style.module.scss';
import { FlexProps } from 'common/components/Flex/types';
import { computeHeight, computeWidth } from 'common/components/utils.ts';

const boundedClassNames = binder.bind(s);

// todo: check for flex property usages. should be removed for 1, 2, 3, 4, 5 usages
const Flex = ({
  justify,
  align,
  row = false,
  className,
  children,
  flex,
  wrap,
  bgColor,
  color,
  height,
  width,
  style,
  ...rest
}: FlexProps) => {
  return (
    <div
      {...rest}
      className={boundedClassNames({
        [`justify-${justify}`]: justify,
        [`align-${align}`]: align,
        row,
        column: !row,
        wrap,
      })
        .concat(' ', className || ' ', ` ${row ? 'gx-8' : 'gy-8'} `)
        .concat(` bg-${bgColor}`)
        .concat(` text-${color}`)}
      style={{
        flex,
        ...computeHeight(height, true),
        ...computeWidth(width, true),
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Flex;
